// extracted by mini-css-extract-plugin
export default {"ResultPage":"ResultPage_nd_ca"};